import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import GlobalTheme from '@atlaskit/theme/components';
import Container from './internal/components/container';
import Format from './internal/components/format';
import { Theme } from './internal/theme';

/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */
function Badge(_ref) {
  var theme = _ref.theme,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 0 : _ref$children,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Theme.Provider, {
    value: theme
  }, /*#__PURE__*/React.createElement(GlobalTheme.Consumer, null, function (_ref2) {
    var mode = _ref2.mode;
    return /*#__PURE__*/React.createElement(Theme.Consumer, {
      appearance: appearance,
      mode: mode
    }, function (tokens) {
      return /*#__PURE__*/React.createElement(Container, _extends({}, tokens, {
        "data-testid": testId
      }), typeof children === 'string' ? children : /*#__PURE__*/React.createElement(Format, {
        max: max
      }, children));
    });
  }));
}

Badge.displayName = 'Badge';
export default Badge;